
import "@sparta.sb-credit-cards.modules/more-less-cc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/comparison-table-cc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/standard-features-cc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/more-cards-cc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/compare-add-modal-cc-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"

import "@sparta.sb-credit-cards.modules/more-less-cc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/comparison-table-cc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/standard-features-cc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/more-cards-cc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/compare-add-modal-cc-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
  console.log('after - execute boot functions')
})();
